module.exports = __webpack_public_path__ + "static/calm-beach.14caf334.jpg";